import InfluencerRequestsTable from './InfluencerRequestsTable';

export default InfluencerRequestsTable;
